import Android from "../../images/android.png";
import Hardware from "../../images/hardware.png";
import WebApp from "../../images/webapp.png";
import Software from "../../images/software.png";
import Marketing from "../../images/marketing.png";
import ThreeD from "../../images/threeD.png";

const ServiceData = [
  {
    img: WebApp,
    title: "Web Application",
    description:
      "A web application (or web app) is application software that runs on a web server, unlike computer-based software programs that are run locally on the operating system (OS) of the device.",
  },
  {
    img: Hardware,
    title: "Hardware Project",
    description:
      "KitsWare Technology provides self learning hardware based projects Kits on various electronics as well as electronics and communication engineering research and development hardware base project ",
  },
  {
    img: Android,
    title: "Mobile Application",
    description:
      "Android software development is the process by which applications are created for devices running the Android operating system and using Kotlin, Java, and C++ languages .",
  },
  {
    img: Software,
    title: "Software Development",
    description:
      "Software development is the process of conceiving, specifying, designing, programming, documenting, testing, and bug fixing involved in creating and maintaining applications, frameworks, or other software components.",
  },
  {
    img: Marketing,
    title: "Digital Marketing",
    description:
      "Digital marketing involves the promotion of products and services through a variety of digital channels, using the internet and mobile technology. Push and pull marketing techniques are applied, targeting consumers both directly and indirectly.",
  },
  {
    img: ThreeD,
    title: "3D Printing",
    description:
      "Three-dimensional (3D) printing is an additive manufacturing process that creates a physical object from a digital design. The process works by laying down thin layers of material in the form of liquid or powdered plastic, metal or cement.",
  },
];
export default ServiceData;
